export default __webpack_public_path__ + "static/media/erCode.25eb8bd3.jpeg";